import React from "react"
import styled from "styled-components"
import {Nav, NavItem} from "react-bootstrap"

import {label3} from "@irati/ui/src/Labels/css/labels"
import {greys} from "@irati/ui/src/global/colors"

interface Props {
  activeColor: string
  fullWidth: boolean
}

export const StyledNav = styled(Nav)``

export const StyledNavItem = styled(({activeColor, fullWidth, ...rest}: Props) => <NavItem {...rest} />).attrs({
  // @ts-ignore
  bold: "true"
})`
  margin-right: ${({theme}) => theme.spacing.two};
  &&& {
    ${({fullWidth}: Props) =>
      fullWidth &&
      `
      float: none;
      display: table-cell;
      width: 1%;
    `}
    &+& {
      margin-left: 0;
    }
    &.active {
      a {
        &,
        &:hover,
        &:focus {
          ${({activeColor}: Props) =>
            activeColor &&
            `
            border-bottom: 5px solid ${activeColor};
          `}
        }
        &:focus {
          background-color: transparent;
        }
        &:hover {
          background-color: ${greys.light};
        }
      }
    }
    a {
      &,
      &:hover,
      &:focus {
        ${label3}
        background-color: transparent;
        color: ${greys.black};
        border-radius: 0;
        padding: 15px 10px 10px;
        text-align: center;
      }

      &:hover,
      &:focus {
        background-color: ${greys.light};
        border-bottom: 5px solid ${greys.light};
      }
    }
  }
`

export const StyledBadge = styled.span`
  height: ${({theme}) => theme.spacing.one};
  width: ${({theme}) => theme.spacing.one};
  border-radius: ${({theme}) => theme.spacing.half};
  background-color: ${({theme}) => theme.colors.tertiary.r_400};
  position: absolute;
  right: 0;
`
